import {
  Annotation,
  Axis,
  Chart,
  Coordinate,
  G2,
  Interval,
  Legend,
  Line,
  Point,
  Tooltip,
} from 'bizcharts';
import { IEvent } from 'bizcharts/lib/interface';
import { useOrderCountRankChart } from './provider/OrderCountRankChartProvider';

export type TraderOrderRankChartDataType = {
  orderCount: number;
  orderAmount: number;
  custDes: string;
  custCode: string;
  startDt: string;
  endDt: string;
};

export const OrderCountRankChart = () => {
  const { filteredData } = useOrderCountRankChart();
  let chartIns: G2.Chart | null = null;
  const scale = {
    orderCount: {
      min: 0,
      tickCount: 4,
      alias: '주문건수',
      type: 'linear-strict',
      formatter: (d: number) => `${d.toLocaleString()}회`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    },
    custDes: {
      formatter: (d: string) => `${d}`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    },
  };

  const colors = ['#699bff', '#fd6666'];

  return (
    filteredData.length > 0 && (
      <div>
        <Chart
          scale={scale}
          autoFit
          height={400}
          data={filteredData.sort((a, b) => a.orderCount - b.orderCount)}
          // padding={[40, 40, 50, 105]}
          onGetG2Instance={(chart: G2.Chart) => {
            chartIns = chart;
          }}
        >
          <Axis
            name='custDes'
            label={{
              formatter: (text) =>
                text.length > 10 ? text.slice(0, 8) + '...' : text, // 10글자 초과 시 "..."
              style: {
                fontSize: 12,
                fill: '#333',
              },
            }}
          />
          <Coordinate transpose />
          <Interval position='custDes*orderCount' color={colors[0]} size={15} />
        </Chart>
      </div>
    )
  );
};
